import React, { useEffect } from "react";
import { injectIntl } from "react-intl";
import { compose } from "redux";
import { useDispatch, useSelector } from "react-redux";
import * as ReducerKeys from "../constants/reducerKeys";
import {
  LiveSessionAlert,
  LiveStreamsCarouselsFeaturedLives,
  LiveStreamsCarouselsNextLives,
  LiveStreamsCarouselsPreviousLives,
  LiveStreamsLandingHeader,
} from "../component";
import injectMultipleReducers from "../../../utils/reducers/injectMultipleReducers";
import injectSaga from "../../../utils/saga/injectSaga";
import { liveStreamReducer, userReducer } from "../reducer";
import saga from "../saga";
import { useLiveStreamActions, useUserDomainActions } from "../customHooks";
import When from "../../../common/When";
import {
  setupHoneybadger,
  removeHoneybadger,
} from "../../../../js/utils/errorTracking/honeybadger";
import { LiveSessionProvider } from "../context/LiveSessionContext";

export const LiveStreamsLanding = () => {
  const {
    loadingFeaturedLives,
    loadingNextLives,
    errorFetchingFeaturedLives,
    errorFetchingNextLives,
    featuredLives,
    nextLives,
  } = useSelector((state) => state[ReducerKeys.LIVE_STREAM]);

  const { errorFetchingUser, user } = useSelector((state) => state[ReducerKeys.USER]);

  const dispatch = useDispatch();
  const { getFeaturedLives, getNextLives } = useLiveStreamActions();
  const { getCurrentWithoutRelationshipsUser } = useUserDomainActions({ dispatch });

  const showLiveStreamAlert = () => errorFetchingFeaturedLives || errorFetchingNextLives;

  useEffect(() => {
    getCurrentWithoutRelationshipsUser();
    getFeaturedLives();
    getNextLives();
    setupHoneybadger();
    return () => {
      removeHoneybadger();
    };
  }, []);

  return (
    <>
      <When condition={showLiveStreamAlert()}>
        {() => <LiveSessionAlert type="error" message="generic.messages.error_try_again" top={8} />}
      </When>
      <LiveStreamsLandingHeader />
      <LiveSessionProvider
        value={{
          featuredLives,
          nextLives,
          user: errorFetchingUser ? { id: null } : user,
        }}
      >
        <When condition={loadingFeaturedLives || !!featuredLives?.length}>
          {() => <LiveStreamsCarouselsFeaturedLives />}
        </When>
        <When condition={loadingNextLives || !!nextLives?.length}>
          {() => <LiveStreamsCarouselsNextLives />}
        </When>
        <LiveStreamsCarouselsPreviousLives />
      </LiveSessionProvider>
    </>
  );
};

const withReducers = injectMultipleReducers([
  { key: ReducerKeys.LIVE_STREAM, reducer: liveStreamReducer },
  { key: ReducerKeys.USER, reducer: userReducer },
]);

const withSaga = injectSaga({ key: "course[live]", saga });

export default compose(withReducers, withSaga)(injectIntl(LiveStreamsLanding));
